export default __webpack_public_path__ + "static/media/noProject.e741b247.png";